import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { ThemeProvider } from '@mui/material';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';

function InputWithAutocomplete(props) {
  const {
    entity,
    error,
    theme,
    autoCompleteStyles,
    disabled,
    autocompleteValues,
    fieldValue,
    changeHandler,
    placeholder,
    clearSuggestions = () => {}
  } = props;

  return (
    <ThemeProvider theme={theme}>
      <Autocomplete
        freeSolo
        loading
        disableClearable
        loadingText={`Please type first 3 letters of your ${entity}`}
        isOptionEqualToValue={async (option, value) => (await option.label) === value}
        onBlur={(e) => {
          const match = autocompleteValues.find((x) => x.label === e.target.value);
          clearSuggestions(entity);
          if (match) return;
          changeHandler({ entity, value: '' });
        }}
        onFocus={(e) => changeHandler({ entity, value: e.target.value }, false)}
        sx={autoCompleteStyles}
        onInput={(e) => {
          changeHandler({ entity, value: e.target.value });
        }}
        onSelect={(e) => {
          changeHandler({ entity, value: e.target.value });
        }}
        value={fieldValue}
        disablePortal
        disabled={disabled}
        id="country"
        options={autocompleteValues}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            type="text"
            placeholder={placeholder}
            InputProps={{ ...params.InputProps, style: { fontSize: `14px` } }}
          />
        )}
      />
      {!fieldValue && error && <ValidationErrorLabel message={error} />}
    </ThemeProvider>
  );
}

export default InputWithAutocomplete;
